export default "__VITE_ASSET__DHeDA4Yr__"